/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import isUndefined from"./isUndefined";import isString from"./isString";const startsWith=function(i,t){return!isUndefined(i)&&!isUndefined(t)&&(isString(i)||(i=`${i}`),isString(t)||(t=`${t}`),i.substr(0,t.length)===t)};export default startsWith;